module.exports = __webpack_public_path__ + "static/media/whiteBoard-capitals.1cb044f6.png";